<template>
  <div class="page-container">
    <div class="flex justify-end">
      <div class="buttons-cont">
        <button
          :disabled="
            selectedCollegesToMerge.length <= 0 || targetCollege === null
          "
          class="merge-button"
          :title="
            selectedCollegesToMerge.length <= 0 || targetCollege === null
              ? 'Select both target college and unverified colleges to merge'
              : 'Proceed to verify your selection and merge.'
          "
          @click="showSelectedList = !showSelectedList"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19 8.00008V6.00008H15.4142L19.7071 1.70718L18.2929 0.292969L14 4.58586V1.00008H12V8.00008H19ZM5.00001 5.00008V10.0001H3.00001V3.00008H10V5.00008H5.00001ZM15 10.0001V15.0001H10V17.0001H17V10.0001H15ZM1.70712 19.7072L6.00001 15.4143V19.0001H8.00001V12.0001H1.00001V14.0001H4.5858L0.292908 18.293L1.70712 19.7072Z"
              fill="white"
            />
          </svg>
          Proceed to Merge
        </button>
        <button
          class="verify-button"
          :title="
            selectedCollegesToMerge.length <= 1
              ? 'Select multiple colleges to verify at once'
              : 'Verify all selected colleges'
          "
          :disabled="selectedCollegesToMerge.length <= 1"
          @click="requestBulkCollegeVerification"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 -11 512.02797 512"
          >
            <path
              d="m441.644531 247.59375-11.457031-32.554688-123.582031 123.585938c-12.074219 12.097656-28.160157 18.75-45.25 18.75-17.085938 0-33.171875-6.652344-45.246094-18.75l-90.667969-90.667969c-12.097656-12.074219-18.753906-28.160156-18.753906-45.246093 0-17.089844 6.65625-33.175782 18.753906-45.25 12.074219-12.09375 28.160156-18.75 45.246094-18.75 17.089844 0 33.175781 6.65625 45.25 18.75l45.417969 45.398437 121.6875-121.683594-8.195313-23.253906-3.773437-22.570313c-2.367188-14.464843-11.90625-26.453124-25.453125-32.066406-13.609375-5.652344-28.796875-3.902344-40.722656 4.652344l-59.285157 42.921875-59.949219-43.03125c-12.03125-8.488281-27.261718-10.175781-40.789062-4.5-13.4375 5.632813-22.890625 17.601563-25.257812 31.980469l-11.605469 72.253906-72.683594 12.074219c-14.441406 2.371093-26.429687 11.90625-32.0625 25.453125-5.632813 13.589844-3.882813 28.820312 4.671875 40.746094l42.902344 59.285156-43.03125 59.945312c-8.46875 12.03125-10.175782 27.285156-4.5 40.789063 5.652344 13.441406 17.597656 22.890625 31.976562 25.261719l72.257813 11.625 12.074219 72.660156c2.347656 14.421875 11.820312 26.390625 25.257812 32.023437 13.546875 5.671875 28.800781 3.988281 40.941406-4.609375l59.285156-42.921875 59.796876 42.921875c7.316406 5.226563 15.828124 7.914063 24.46875 7.914063 5.480468 0 10.984374-1.066407 16.253906-3.261719 13.570312-5.632812 23.085937-17.621094 25.453125-32.023438l11.625-72.253906 72.660156-12.074218c14.421875-2.371094 26.371094-11.820313 32.023437-25.261719 5.675782-13.503907 3.988282-28.757813-4.609374-40.9375zm0 0"
              fill="#ffc107"
            />
            <path
              d="m261.355469 314.710938c-5.460938 0-10.921875-2.089844-15.082031-6.25l-90.667969-90.667969c-8.339844-8.339844-8.339844-21.824219 0-30.164063 8.34375-8.34375 21.824219-8.34375 30.167969 0l75.582031 75.582032 214.25-214.25c8.34375-8.339844 21.824219-8.339844 30.167969 0 8.339843 8.339843 8.339843 21.824218 0 30.164062l-229.335938 229.335938c-4.160156 4.160156-9.621094 6.25-15.082031 6.25zm0 0"
              fill="#fff"
            />
          </svg>
          Verify All
        </button>

        <button
          class="add-button"
          title="Add tags to college"
          @click="displayTagsModal"
        >
          Add Tag
        </button>
        <button
          class="add-button"
          title="Add new college"
          @click="showNewCollegeForm"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.7778 6H14V2.22222C14 0.994923 13.186 0 12.1818 0H7.81818C6.81403 0 6 0.994923 6 2.22222V6H2.22222C0.994923 6 0 6.81403 0 7.81818V12.1818C0 13.186 0.994923 14 2.22222 14H6V17.7778C6 19.0051 6.81403 20 7.81818 20H12.1818C13.186 20 14 19.0051 14 17.7778V14H17.7778C19.0051 14 20 13.186 20 12.1818V7.81818C20 6.81403 19.0051 6 17.7778 6ZM18 8H12V2H8V8H2V12H8V18H12V12H18V8Z"
              fill="white"
            />
          </svg>
          Add College
        </button>
      </div>
    </div>
    <div class="relative block m-auto input-cont" title="Search for colleges">
      <svg
        class="search-icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="$refs.searchInput.focus()"
      >
        <path
          d="M10.9167 9.66667H10.2583L10.025 9.44167C10.8417 8.49167 11.3333 7.25833 11.3333 5.91667C11.3333 2.925 8.90833 0.5 5.91667 0.5C2.925 0.5 0.5 2.925 0.5 5.91667C0.5 8.90833 2.925 11.3333 5.91667 11.3333C7.25833 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z"
          fill="#C2CFE0"
        />
      </svg>

      <input
        ref="searchInput"
        v-model="query"
        autofocus="true"
        type="search"
        name="Search for college"
        placeholder="Search for College"
        class="p-6 pl-12 border-none search-input"
        @input="handleInput"
      />
    </div>

    <div class="p-6 ml-8" style="width: 400px;">
      <div class="mb-2">Search by Tag</div>
      <VueSelect
        class="bg-white"
        label="name"
        :options="tagOptions"
        :reduce="tag => tag.name"
        @input="handleTagSelection"
      />
    </div>

    <div
      class="drop-area"
      style="padding: 0.7rem"
      title="Drag and drop verified college here"
    >
      <span v-if="targetCollege !== null" class="mb-2">Target College:</span>
      <div v-if="targetCollege !== null" class="w-full flex">
        <span
          class="cursor-pointer"
          title="Remove"
          @click="targetCollege = null"
          ><svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="red"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1"
              y="1"
              width="14"
              height="14"
              rx="3"
              stroke="#D5D5D5"
              stroke-width="2"
            /></svg
        ></span>
        <span class="px-8 text-left flex-grow">{{ targetCollege.name }}</span>
        <span>{{ targetCollege.id }}</span>
      </div>
      <span v-else class="my-6">
        Drag and drop your target college here
      </span>
    </div>
    <div class="result-list my-4 m-auto">
      <div
        style="cursor: default;"
        class="item-cont py-3 px-4 flex flex-row justify-between mb-2"
      >
        <div class="action-button-cont">
          <button
            class="check-box-icon cursor-pointer"
            title="Select all"
            @click="selectAllColleges"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              :fill="selectedAllColleges ? '#00b31e' : 'none'"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="1"
                y="1"
                width="14"
                height="14"
                rx="3"
                stroke="#D5D5D5"
                stroke-width="2"
              />
            </svg>
            <span
              v-if="selectedCollegesToMerge.length > 0"
              class="ml-2 text-green absolute font-normal"
              @click.stop="showSelectedList = true"
            >
              ({{ selectedCollegesToMerge.length }}) Clgs.</span
            >
          </button>
        </div>
        <div
          :title="
            currentSortingOrder === 'name&order=ascending'
              ? 'Sort by descending order'
              : 'Sort by ascending order'
          "
          class="college-name select-none college-name px-4 cursor-pointer"
          @click="toggleSortingOrderByName"
        >
          College Name
          <span class="text-xs">{{
            currentSortingOrder === "name&order=ascending" ? "▲" : "▼"
          }}</span>
        </div>
        <div class="college-id">
          Tags
        </div>
        <div class="college-id">
          College ID
        </div>
        <div
          class="updated-on cursor-pointer"
          :title="
            currentSortingOrder === 'created_on'
              ? 'Sort by updated on time'
              : 'Sort by created on time'
          "
          @click="toggleSortingOrderByTime"
        >
          Updated On
          <span class="text-xs">{{
            currentSortingOrder === "created_on" ? "▲" : "▼"
          }}</span>
        </div>
      </div>
      <div id="list" class="relative">
        <div
          v-for="(college, idx) in getFilteredColleges"
          :id="college.id"
          :key="college.id"
          :style="
            dragStared && draggedCollege.id === college.id
              ? `transform: translate(${getXPosition}px, ${getYPosition}px; transition: none;`
              : ''
          "
          class="item-cont p-4 py-3 flex flex-row justify-between select-none"
          :class="
            collegeSelected(college.id)
              ? 'college-selected'
              : dragStared && draggedCollege.id === college.id
              ? 'dragged-item'
              : ''
          "
          title="Drag college and drop in above area to select as target college"
          @mousedown="handleMousedown($event, college)"
          @mouseup="handleMouseUp"
        >
          <div class="action-button-cont flex items-center justify-between">
            <!-- oddly calculating the item number  -->
            <span class="mr-2">{{ per_page * page - per_page + idx + 1 }}</span>
            <div class="flex justify-between">
              <button
                class="cursor-pointer check-box-icon"
                title="Select college"
                @click.stop.prevent="toggleCollegeSelection(college.id)"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  :fill="collegeSelected(college.id) ? '#00b31e' : 'none'"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="1"
                    width="14"
                    height="14"
                    rx="3"
                    stroke="#D5D5D5"
                    stroke-width="2"
                  />
                </svg>
              </button>
              <button
                class="cursor-pointer ml-2 verify-btn-cont"
                :title="
                  college.verified ? 'Click to unverify' : 'Click to verify.'
                "
              >
                <svg
                  v-if="college.verified"
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="20"
                  viewBox="0 -11 512.02797 512"
                  @click.stop="revertCollegeVerification([college])"
                >
                  <path
                    d="m441.644531 247.59375-11.457031-32.554688-123.582031 123.585938c-12.074219 12.097656-28.160157 18.75-45.25 18.75-17.085938 0-33.171875-6.652344-45.246094-18.75l-90.667969-90.667969c-12.097656-12.074219-18.753906-28.160156-18.753906-45.246093 0-17.089844 6.65625-33.175782 18.753906-45.25 12.074219-12.09375 28.160156-18.75 45.246094-18.75 17.089844 0 33.175781 6.65625 45.25 18.75l45.417969 45.398437 121.6875-121.683594-8.195313-23.253906-3.773437-22.570313c-2.367188-14.464843-11.90625-26.453124-25.453125-32.066406-13.609375-5.652344-28.796875-3.902344-40.722656 4.652344l-59.285157 42.921875-59.949219-43.03125c-12.03125-8.488281-27.261718-10.175781-40.789062-4.5-13.4375 5.632813-22.890625 17.601563-25.257812 31.980469l-11.605469 72.253906-72.683594 12.074219c-14.441406 2.371093-26.429687 11.90625-32.0625 25.453125-5.632813 13.589844-3.882813 28.820312 4.671875 40.746094l42.902344 59.285156-43.03125 59.945312c-8.46875 12.03125-10.175782 27.285156-4.5 40.789063 5.652344 13.441406 17.597656 22.890625 31.976562 25.261719l72.257813 11.625 12.074219 72.660156c2.347656 14.421875 11.820312 26.390625 25.257812 32.023437 13.546875 5.671875 28.800781 3.988281 40.941406-4.609375l59.285156-42.921875 59.796876 42.921875c7.316406 5.226563 15.828124 7.914063 24.46875 7.914063 5.480468 0 10.984374-1.066407 16.253906-3.261719 13.570312-5.632812 23.085937-17.621094 25.453125-32.023438l11.625-72.253906 72.660156-12.074218c14.421875-2.371094 26.371094-11.820313 32.023437-25.261719 5.675782-13.503907 3.988282-28.757813-4.609374-40.9375zm0 0"
                    fill="#ffc107"
                  />
                  <path
                    d="m261.355469 314.710938c-5.460938 0-10.921875-2.089844-15.082031-6.25l-90.667969-90.667969c-8.339844-8.339844-8.339844-21.824219 0-30.164063 8.34375-8.34375 21.824219-8.34375 30.167969 0l75.582031 75.582032 214.25-214.25c8.34375-8.339844 21.824219-8.339844 30.167969 0 8.339843 8.339843 8.339843 21.824218 0 30.164062l-229.335938 229.335938c-4.160156 4.160156-9.621094 6.25-15.082031 6.25zm0 0"
                    fill="#00b31e"
                  />
                </svg>
                <span
                  v-else
                  class="verify-btn"
                  @click.stop="requestCollegeVerification(college)"
                  >Verify</span
                >
              </button>
            </div>
          </div>
          <span class="px-4 text-left college-name">{{ college.name }}</span>
          <div v-if="college.college_tags.length" class="tag-id flex flex-wrap">
            <span
              v-for="tag in college.college_tags"
              :key="tag.id"
              class="mr-2 mt-2 p-1 rounded bg-grey-light whitespace-pre"
              >{{ tag.name }}</span
            >
          </div>
          <span class="college-id">{{ college.id }}</span>
          <span class="updated-on">{{
            getFormattedDateTime(college.updated_on)
          }}</span>
        </div>
      </div>
      <div class="navigation-section flex justify-center items-center mt-4">
        <button
          :disabled="page === 1"
          @click="handleNavigationButtonClick('prev')"
        >
          <img
            class="navigation-icon"
            src="../../assets/icons/svg/right.svg"
            alt="left page icon"
            style="transform: scaleX(-1)"
          />
        </button>
        <PaginationList
          v-if="pages && page"
          :pages="pages"
          :page="page"
          @click="handleClick"
        />
        <button
          :disabled="page === pages"
          @click="handleNavigationButtonClick('next')"
        >
          <img
            class="navigation-icon"
            src="../../assets/icons/svg/right.svg"
            alt="next page icon"
          />
        </button>
      </div>
    </div>
    <div v-if="showSelectedList" class="modal-bg" @click="hideModal">
      <div class="w-full selected-list">
        <div class="mb-8 text-center">
          <h4>Target College</h4>
          <span v-if="targetCollege !== null">{{ targetCollege.name }}</span>
          <span v-else class="text-red mt-2 block">Not Selected any!</span>
        </div>
        <h4 class="mb-2">
          Colleges to be merged:
          <span class="text-red"
            >{{ selectedCollegesToMerge.length }} selected</span
          >
        </h4>
        <div
          v-for="college in selectedCollegesToMerge"
          :key="college.id + 'selected'"
          class="flex p-2"
        >
          <span class="px-4 text-left flex-grow">{{ college.name }}</span>
          <span>{{ college.id }}</span>
        </div>
        <div class="flex justify-end">
          <button
            class="merge-button"
            :disabled="
              selectedCollegesToMerge.length <= 0 || targetCollege === null
            "
            @click="requestCollegeMerge"
          >
            <svg
              v-show="!inProgress"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19 8.00008V6.00008H15.4142L19.7071 1.70718L18.2929 0.292969L14 4.58586V1.00008H12V8.00008H19ZM5.00001 5.00008V10.0001H3.00001V3.00008H10V5.00008H5.00001ZM15 10.0001V15.0001H10V17.0001H17V10.0001H15ZM1.70712 19.7072L6.00001 15.4143V19.0001H8.00001V12.0001H1.00001V14.0001H4.5858L0.292908 18.293L1.70712 19.7072Z"
                fill="white"
              />
            </svg>
            <div v-if="inProgress" class="loader"></div>
            <span v-else>Merge Colleges</span>
          </button>
          <button
            ref="modalCloseButton"
            class="close-button"
            @click="showSelectedList = false"
          >
            Close
          </button>
        </div>
      </div>
    </div>

    <VModal
      name="add-tags-modal"
      :click-to-close="true"
      width="600"
      height="300"
      style="overflow: visible !important"
    >
      <div class="w-3/4 m-auto">
        <div class="mt-6 pt-12">
          <div class="mb-2">Tag ID</div>
          <VueSelect
            ref="tagOptions"
            label="name"
            :options="tagOptions"
            :reduce="tag => tag.name"
            multiple
            taggable
          />
        </div>

        <div class="buttons-cont mt-8 flex items-center">
          <button
            class="text-right add-button"
            :disabled="inProgress"
            @click="() => tagCollege()"
          >
            <div v-if="inProgress" class="loader"></div>
            <span v-else>
              Add Tags
            </span>
          </button>
        </div>
      </div>
    </VModal>

    <VModal
      name="add-college-modal"
      :click-to-close="true"
      width="600"
      height="300"
      style="overflow: visible !important"
    >
      <form
        class="flex flex-col justify-between p-8 2-full h-full bg-white"
        @submit.prevent.stop="requestNewCollegeAddition"
      >
        <div>
          <label
            for="add-college"
            class="text-base form-label"
            style="font-size: 1rem;"
            >Add New College</label
          >
          <input
            id="add-college"
            v-model="newCollegeName"
            type="text"
            class="w-full mt-4 shadow-md"
            placeholder="Enter College Name"
            name="add-college"
          />
          <div class="flex mt-4 items-center mb-2">
            <label
              for="verify-new-college"
              style="font-size: 1rem;"
              @click.stop.prevent="verifyNewCollege = !verifyNewCollege"
              >Mark as verified?</label
            >
            <div
              id="verify-new-college"
              class="cursor-pointer check-box-icon ml-4"
              title="Select college"
              @click.stop.prevent="verifyNewCollege = !verifyNewCollege"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                :fill="verifyNewCollege ? '#00b31e' : 'none'"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="1"
                  y="1"
                  width="14"
                  height="14"
                  rx="3"
                  stroke="#D5D5D5"
                  stroke-width="2"
                />
              </svg>
            </div>
          </div>
          <small
            v-if="!verifyNewCollege"
            class="text-xs text-red-light mt-2 mb-8"
            >* Verifying this college will allow you to merge unverified
            duplicate colleges into it.</small
          >

          <div class="mt-6">
            <div class="mb-2">Tag ID</div>
            <VueSelect
              ref="tagOptions"
              label="name"
              :options="tagOptions"
              :reduce="tag => tag.name"
              multiple
              taggable
            />
          </div>
        </div>

        <div class="buttons-cont mt-8 flex items-center">
          <button
            class="text-right add-button"
            :disabled="inProgress"
            type="submit"
          >
            <div v-if="inProgress" class="loader"></div>
            <span v-else>
              Add
            </span>
          </button>
        </div>
      </form>
    </VModal>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"
import PaginationList from "@/components/CollegeCleanup/PaginationList"

export default {
  components: {
    VueSelect,
    PaginationList,
  },
  data() {
    return {
      selectedTag: undefined,
      tagOptions: [],
      query: "",
      colleges: [],
      dragStared: false,
      allowDrop: false,
      targetCollege: null,
      selectedCollegesToMerge: [],
      selectedAllColleges: false,
      draggedCollege: null,
      showSelectedList: false,
      initialX: 0,
      initialY: 0,
      currentX: 0,
      currentY: 0,
      page: 1,
      pages: 0,
      per_page: 15,
      reachedEndOfResult: false,
      currentSortingOrder: "name&order",
      debounceId: null,
      newCollegeName: "",
      verifyNewCollege: true,
      inProgress: false,
    }
  },
  computed: {
    getXPosition() {
      return this.currentX - this.initialX
    },
    getYPosition() {
      return this.currentY - this.initialY
    },
    getFilteredColleges() {
      if (this.targetCollege !== null) {
        return this.colleges.filter(
          college => college.id !== this.targetCollege.id
        )
      }
      return this.colleges
    },
  },
  watch: {
    selectedTag() {
      this.fetchColleges()
    },
    showSelectedList(value) {
      if (value) {
        this.$nextTick(() => {
          this.$refs.modalCloseButton.focus()
        })
      }
    },
    currentSortingOrder(newSortingOrder) {
      const newRouteObj = {
        ...this.$route,
        query: { ...this.$route.query, sort_by: newSortingOrder },
      }
      if (
        newSortingOrder === "updated_on" ||
        newSortingOrder === "created_on"
      ) {
        delete newRouteObj.query.order
      }
      this.$router.push(newRouteObj)
    },
    page() {
      const newRouteObj = {
        ...this.$route,
        query: { ...this.$route.query, page: this.page },
      }
      this.$router.push(newRouteObj)
    },
    $route() {
      this.fetchColleges()
    },
  },
  created() {
    if (this.$route.query) {
      const { query } = this.$route
      if (query.sort_by) {
        this.currentSortingOrder = query.sort_by
      }
      if (query.page) {
        this.page = parseInt(query.page)
      }
      if (query.per_page) {
        this.per_page = parseInt(query.per_page)
      }
      if (query.search) {
        this.query = query.search
      }
    }
    this.fetchColleges()
  },
  mounted() {
    this.getTags().then(res => {
      this.tagOptions = res.data.tags
    })
    const container = document.querySelector(".page-container")
    container.addEventListener("mousemove", this.handleMousemove)
  },
  beforeDestroy() {
    const container = document.querySelector(".page-container")
    if (container) {
      container.removeEventListener("mousemove", this.handleMousemove)
    }
  },
  methods: {
    handleTagSelection(tag) {
      this.selectedTag = tag ? tag.name : undefined
    },
    async tagCollege(newCollegeName = false) {
      const tags = this.$refs.tagOptions.valueAsArray
      const selectedTags = tags.filter(tag => tag.id)

      let newTags = tags.filter(tag => (tag.id ? !tag.id : tag))
      newTags = newTags.map(tag => (tag.name ? tag.name : tag))
      if (newTags.length) {
        await this.createTags(newTags)
        const tagsRes = await this.getTags()
        this.tagOptions = tagsRes.data.tags
      }
      const mapNewTags = []
      this.tagOptions.forEach(tag => {
        if (newTags.includes(tag.name)) {
          mapNewTags.push(tag)
        }
      })
      const allTags = [...selectedTags, ...mapNewTags]

      if (newCollegeName) {
        // tags for add new college
        return allTags
      }
      // tag a list of colleges
      const institution_ids = this.selectedCollegesToMerge.map(c => c.id)
      const tag_ids = allTags.map(t => t.id)
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}institution/add_tags_to_the_college`,
        data: { institution_ids, tag_ids },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.$noty.success(res.data.message)
        this.fetchColleges()
        this.$modal.hide("add-tags-modal")
      })
      return true
    },
    createTags(tags) {
      return this.axios({
        method: "post",
        url: `${siteConfig.siteURL}institution/create_college_tag`,
        data: { tags },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
    },
    setSelectedTag(question) {
      const option = this.tagOptions.filter(tag => tag.id === question.tag_id)
      return option.length ? option[0].name : ""
    },
    getTags() {
      return this.axios({
        method: "get",
        url: `${siteConfig.siteURL}institution/get_college_tags`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
    },
    getFormattedDateTime(updated_on) {
      const date = new Date(updated_on)
      return `${date.getHours()}:${date.getMinutes()} ${date.toLocaleDateString()}`
    },
    toggleSortingOrderByTime() {
      if (this.currentSortingOrder === "created_on") {
        this.currentSortingOrder = "updated_on"
      } else {
        this.currentSortingOrder = "created_on"
      }
    },
    toggleSortingOrderByName() {
      if (this.currentSortingOrder === "name&order=ascending") {
        this.currentSortingOrder = "name&order=descending"
      } else {
        this.currentSortingOrder = "name&order=ascending"
      }
    },
    handleClick(newPage) {
      this.page = newPage
    },
    handleNavigationButtonClick(way) {
      if (way === "next" && this.page < this.pages) {
        this.page += 1
      } else if (way === "prev" && this.page > 1) {
        this.page -= 1
      }
      this.fetchColleges()
    },
    hideModal(e) {
      if (e.target.classList.contains("modal-bg")) {
        this.showSelectedList = false
      }
    },
    handleMousedown(e, college) {
      if (!this.collegeSelected(college.id)) {
        this.dragStared = true
        this.draggedCollege = college
        this.initialX = e.clientX
        this.initialY = e.clientY
        this.currentX = this.initialX
        this.currentY = this.initialY
      }
    },
    handleMousemove(e) {
      if (this.dragStared && !this.collegeSelected(this.draggedCollege.id)) {
        this.currentX = e.clientX
        this.currentY = e.clientY
      }
    },
    handleMouseUp(e) {
      const dropAreaRect = document
        .querySelector(".drop-area")
        .getBoundingClientRect()
      if (
        e.clientX >= dropAreaRect.left &&
        e.clientX <= dropAreaRect.right &&
        e.clientY >= dropAreaRect.top &&
        e.clientY <= dropAreaRect.bottom &&
        !this.collegeSelected(this.draggedCollege.id) &&
        this.dragStared
      ) {
        this.targetCollege = this.draggedCollege
      }
      this.dragStared = false
      this.draggedCollege = {}
    },
    handleInput() {
      this.page = 1
      clearTimeout(this.debounceId)
      this.debounceId = setTimeout(() => {
        const newRouteObj = {
          ...this.$route,
          query: { ...this.$route.query, search: this.query },
        }
        if (!this.query) {
          delete newRouteObj.query.search
        }
        this.$router.push(newRouteObj)
      }, 500)
    },
    fetchColleges() {
      const loader = this.$loading.show()
      this.getInstitutions(
        this.query,
        this.page,
        this.per_page,
        this.currentSortingOrder
      )
        .then(res => {
          this.colleges = res.data.items
          this.page = res.data.page
          this.pages = res.data.pages
          loader.hide()
        })
        .catch(err => {
          loader.hide()
          console.error(err)
        })
    },
    getInstitutions(query, page = 1, per_page = 15, sort_by) {
      let url
      if (query) {
        url = `${
          siteConfig.siteURL
        }institution/?search=${query}&sort_by=${sort_by}&page=${page}&per_page=${per_page}${
          this.selectedTag ? `&college_tag=${this.selectedTag}` : ""
        }`
      } else {
        url = `${siteConfig.siteURL}institution/?sort_by
=${sort_by}&page=${page}&per_page=${per_page}${
          this.selectedTag ? `&college_tag=${this.selectedTag}` : ""
        }`
      }
      return this.axios.get(url)
    },
    toggleCollegeSelection(id) {
      if (this.collegeSelected(id)) {
        this.selectedCollegesToMerge = this.selectedCollegesToMerge.filter(
          college => college.id !== id
        )
      } else {
        this.selectedCollegesToMerge.push(
          this.colleges.find(college => college.id === id)
        )
      }
    },
    requestCollegeVerification(college, newlyAdded = false) {
      const text = newlyAdded
        ? `Added new college: ${college.name}, do you want to mark it as verfied?`
        : `Are you sure you want to mark ${college.name} as verfied ?`
      this.$swal({
        title: "Verify College",
        text,
        buttons: ["No, close", "Yes, verify"],
      }).then(value => {
        if (value) {
          const loader = this.$loading.show()
          const url = `${siteConfig.siteURL}institution/institutions/verify`
          this.axios({
            method: "post",
            url,
            data: { institutes: [college.id] },
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "x-access-token": localStorage.token,
            },
          })
            .then(res => {
              this.$noty.success(res.data.message)
              /* update FE with verified status */
              const localCopy = JSON.parse(JSON.stringify(this.colleges))
              const verfiedCollege = localCopy.find(
                col => col.id === college.id
              )
              verfiedCollege.verified = true
              this.colleges = localCopy
              loader.hide()
            })
            .catch(err => {
              loader.hide()
              this.$noty.error(
                `Could not mark college as verified, server responded with: ${err}`
              )
            })
        }
      })
    },
    revertCollegeVerification(colleges) {
      this.$swal({
        title: "Mark college as not verified?",
        text: `Are your sure to mark ${colleges.length} college(s) as not verified?`,
        buttons: ["No, close", "Yes, Mark"],
      }).then(value => {
        if (value) {
          const loader = this.$loading.show()
          const url = `${siteConfig.siteURL}institution/institutions/unverify`
          const ids = colleges.map(c => c.id)
          this.axios({
            method: "post",
            url,
            data: { institutes: ids },
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "x-access-token": localStorage.token,
            },
          })
            .then(res => {
              this.$noty.success(res.data.message)
              /* update FE with verified status */
              this.fetchColleges()
              loader.hide()
            })
            .catch(err => {
              loader.hide()
              this.$noty.error(
                `Could not mark college as verified, server responded with: ${err}`
              )
            })
        }
      })
    },
    requestBulkCollegeVerification() {
      this.$swal({
        title: "Verify College",
        text: `Are you sure to mark ${this.selectedCollegesToMerge.length} colleges as verified ?`,
        buttons: ["No, close", "Yes, verify"],
      }).then(value => {
        if (value) {
          const institutes = this.selectedCollegesToMerge.map(c => c.id)
          const loader = this.$loading.show()
          const url = `${siteConfig.siteURL}institution/institutions/verify`
          this.axios({
            method: "post",
            url,
            data: { institutes },
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "x-access-token": localStorage.token,
            },
          })
            .then(res => {
              this.$noty.success(res.data.message)
              /* update FE with verified status */
              const localList = JSON.parse(JSON.stringify(this.colleges))
              localList.forEach(college => {
                if (institutes.includes(college)) {
                  college.verified = true
                }
              })
              this.colleges = localList
              // const verfiedCollege = localCopy.find(
              //   col => col.id === college.id
              // )
              // verfiedCollege.verified = true
              // this.colleges = localCopy
              loader.hide()
            })
            .catch(err => {
              loader.hide()
              this.$noty.error(
                `Could not mark college as verified, server responded with: ${err}`
              )
            })
        }
      })
    },
    collegeSelected(id) {
      return this.selectedCollegesToMerge
        .map(college => college.id)
        .includes(id)
    },
    selectAllColleges() {
      if (this.selectedAllColleges) {
        this.selectedCollegesToMerge = []
        this.selectedAllColleges = false
      } else {
        this.selectedCollegesToMerge = this.getFilteredColleges
        this.selectedAllColleges = true
      }
    },
    requestCollegeMerge() {
      if (
        this.targetCollege &&
        this.targetCollege.id &&
        this.selectedCollegesToMerge.length > 0
      ) {
        this.inProgress = true
        const listOfIds = this.selectedCollegesToMerge.map(
          college => college.id
        )
        const verifiedCollegeId = this.targetCollege.id
        const url = `${siteConfig.siteURL}institution/merge`
        const data = {
          verified_college: verifiedCollegeId,
          unverified_colleges: listOfIds,
        }
        this.axios({
          method: "post",
          url,
          data,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(res => {
            // for few cases backend return 200 with message, so handling error in .then also
            if (res.data.status) {
              this.showSelectedList = false
              this.inProgress = false
              this.selectedCollegesToMerge = []
              this.targetCollege = null
              /* update FE with latest merged data */
              this.fetchColleges()
              this.selectedAllColleges = false
            } else {
              this.inProgress = false
              this.$noty.error(
                `Looks like merge wasn't successfull, server responded with: ${res.data.message}`
              )
            }
          })
          .catch(err => {
            this.$noty.error(
              `Looks like merge wasn't successfull, server responded with: ${err}`
            )
            this.inProgress = false
          })
      }
    },
    displayTagsModal() {
      this.$modal.show("add-tags-modal")
    },
    showNewCollegeForm() {
      this.$modal.show("add-college-modal")
      setTimeout(() => {
        document.querySelector("#add-college").focus()
      }, 350)
    },
    async requestNewCollegeAddition() {
      if (this.newCollegeName && !this.inProgress) {
        this.inProgress = true

        const tags = await this.tagCollege(true)
        const url = `${siteConfig.siteURL}institution/`
        const data = {
          name: this.newCollegeName,
          government_code: "",
          verified: this.verifyNewCollege,
          college_tags: tags.map(tag => tag.id),
        }

        this.axios({
          method: "post",
          url,
          data,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(res => {
            if (res.status === 201) {
              /* add newly created college to top of our FE list */
              this.colleges.unshift(res.data)
              this.$noty.success(`Added new college: ${res.data.name}`)
              this.$modal.hide("add-college-modal")
              this.newCollegeName = ""
              this.verifyNewCollege = true
              this.inProgress = false
              this.$nextTick(() => {
                const newlyAddedCollege = this.$el.querySelector(
                  `#${res.data.id}`
                )
                if (newlyAddedCollege) {
                  newlyAddedCollege.classList.add("animate-addition")
                  setTimeout(() => {
                    newlyAddedCollege.classList.remove("animate-addition")
                  }, 2500)
                }
              })
            } else {
              this.$noty.error(
                `Looks like college addition failed, server responded with: ${res.data}`
              )
            }
          })
          .catch(err => {
            this.$noty.error(
              `Looks like college addition failed, server responded with: ${err}`
            )
            this.inProgress = false
          })
      }
    },
  },
}
</script>

<style>
.v--modal-overlay .v--modal-box {
  overflow: visible !important;
}
</style>

<style scoped>
.action-button-cont button.check-box-icon {
  margin: 0;
}
.navigation-icon {
  width: 100%;
  height: 100%;
}
.college-name {
  width: 47%;
}
.tag-id {
  width: 10%;
  min-width: 180px;
  text-align: left;
}
.college-id {
  width: 10%;
  min-width: 180px;
  text-align: left;
}
.updated-on {
  width: 13%;
  min-width: 100px;
  text-align: left;
}
.action-button-cont {
  width: 11%;
  min-width: 90px;
  max-width: 130px;
}
.input-cont {
  display: block;
  width: 90%;
  margin: auto;
  transition: all 0.2s ease-out;
}

.drop-area {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 1rem auto;
  padding: 2rem 1rem;
  border: 2px dashed #d2d2d2;
  background: white;
  text-align: center;
  justify-content: center;
}

.drop-area > .selected-list {
  overflow: auto;
  height: 100%;
  max-height: 200px;
}

.modal-bg {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #04202a80;
}

.selected-list {
  overflow: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 55%;
  height: auto;
  max-height: 60%;
  padding: 2rem;
  border-radius: 5px;
  background: white;
  box-shadow: 0 10px 68px 22px grey;
  font-size: 14px;
  transform: translate(-50%, -50%);
  animation: fadeIn 0.3s ease-out;
}

.result-list {
  width: 90%;
}

.item-cont {
  display: flex;
  align-items: center;
  width: 100%;
  border-top: 1px solid lightgrey;
  background: white;
  cursor: grab;
  transition: transform 0.2s ease-out;
  will-change: transition;
}

.verify-btn-cont {
  margin: 0;
  margin-left: 0.5rem;
  padding: 0;
  background-color: unset;
}

.check-box-icon {
  width: auto;
  height: 1.2rem;
  padding: 0;
  background-color: unset;
}

.check-box-icon:hover,
.check-box-icon:focus {
  background: transparent;
}

.input-cont > input[type="search"] {
  width: 100%;
  transition: box-shadow 0.2s ease-out;
}

.input-cont > input[type="search"]:hover,
input[type="text"] {
  border: none;
}

.input-cont > input[type="search"]:focus,
input[type="text"]:focus {
  border: none;
  box-shadow: 0 1px 5px 0 grey;
}

.search-icon {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
}

.page-container {
  overflow-x: hidden;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  margin: auto;
  padding-bottom: 5rem;
  background: #e5e5e5;
  font-size: 0.9rem;
}

.buttons-cont {
  display: flex;
  justify-content: flex-end;
  margin: 0.2rem 1rem 0.5rem;
}

.sorting-buttons img {
  width: 1.3rem;
  height: 1.3rem;
  /*padding: 0.2rem;*/
  /*border: 1px solid #b5b5b5;*/
  /*margin: 1rem;*/
}

.buttons-cont > button,
.selected-list button,
.navigation-section > button {
  display: flex;
  margin: 5px;
  padding: 7px 10px;
  border-radius: 3px;
  color: white;
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.24);
  text-shadow: none;
  font-size: 0.9rem;
  font-weight: normal;
  line-height: 1;
  justify-content: space-between;
  align-items: center;
}

.navigation-section > button {
  width: 3rem;
  height: 3rem;
  margin: 0 5px;
}

.verify-btn {
  padding: 1px 5px;
  border-radius: 3px;
  color: white;
  background: #109cf1;
  box-shadow: 0 0px 1px 0 black;
  font-weight: normal;
}

.buttons-cont > button:hover,
.selected-list button,
.verify-btn:hover {
  filter: brightness(0.9);
}

.merge-button {
  background-color: #00b31e;
}

.buttons-cont .verify-button {
  color: #fff;
  background: #109cf1;
}

.add-button,
.close-button,
.navigation-section button,
.sorting-buttons button {
  background: #109cf1;
}

.buttons-cont .sorting-order-selected {
  background: #014067;
}

.buttons-cont > button > svg,
.selected-list button > svg {
  margin-right: 0.5rem;
}

.buttons-cont > button:disabled,
.selected-list button:disabled,
.navigation-section button:disabled {
  background: grey;
  cursor: not-allowed;
}

.dragged-item {
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 8px grey;
  transition: none;
}

.college-selected {
  background: #d7ffff;
  cursor: not-allowed;
}

.add-college-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  margin: auto;
  padding: 2rem;
  border-radius: 5px;
  background: #e5e5e5;
  font-weight: normal;
  transform: translate(-50%, -50%);
}

.add-college-modal button {
  margin: 2rem auto;
  margin-right: 0;
}

.add-college-modal-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #0b0e1787;
}

.animate-addition {
  animation: animateAddition 2s ease;
}

.loader {
  width: 1.3rem;
  height: 1.3rem;
  margin: 0 0.5rem;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

form .buttons-cont,
form button[type="submit"] {
  margin-right: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes animateAddition {
  0% {
    background: lightblue;
  }
  100% {
    background: white;
  }
}
</style>
